import * as Yup from 'yup';
import getLangData from '../../../utils/getLangData';

const Schema = () =>
  Yup.object().shape({
    /*     geolocation: Yup.array().of(Yup.number()).default([-71.9678064, 41.7744146]),
     */ userID: Yup.string().default(''),
    // .required(getLangData().fields.required),
    customerType: Yup.array()
      .of(Yup.string())
      .default(['0']),
    businessName: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    businessNamei18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default(''),
    }).nullable(),
    yearEstablished: Yup.string().default(''),
    companySize: Yup.string().default(''),
    regCompany: Yup.bool().default(false),
    verified: Yup.bool().default(false),
    trusted: Yup.bool().default(false),
  });

export default Schema;
